import styled from 'styled-components';

import { px } from '../../../../../../../contrib/ui';

export const StyledGroupScorecardsSummaryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(0deg, #ededed 0%, #ffffff 50%);

  col {
    width: 8%;
    &:nth-of-type(1) {
      width: 22%;
    }
  }

  tr td.value-wrapper {
    position: relative;
  }

  tr.trow {
    background: linear-gradient(
      0deg,
      white 0%,
      #d1d1d1 var(--bigButtonHeight),
      rgba(255, 255, 255, 0) var(--bigButtonHeight)
    );

    td {
      &:first-of-type {
        div.value {
          font-family: 'DINNextLTPro-Bold';
          font-size: ${px(14)};
        }
      }
    }
  }

  tr {
    td {
      min-width: ${px(29)};
      height: ${px(29)};
      padding: 0;
      p {
        margin: 0;
      }

      font-family: DINNextLTPro-Bold;
      font-size: 3.381vh;
      font-size: ${px(14)};

      &:first-of-type {
        div.value {
          font-family: 'DINNextLTPro-Bold';
          font-size: ${px(14)};
        }
      }
      div.value {
        @mixin centered-text;

        font-family: 'DINNextLTPro-Heavy';
        font-size: ${px(16)};
      }

      div {
        font-family: 'DINNextLTPro-Heavy';
        font-size: ${px(18)};
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
      &:first-child div {
        justify-content: flex-start;
        padding-left: ${px(3)};
      }

      & > div {
        width: ${px(29)};
        height: ${px(29)};
        margin-left: auto;
        margin-right: auto;
      }

      &.text {
        width: 3.5em;
        & > div {
          width: auto;
          height: auto;
        }
      }

      &.squared-filled {
        & > div {
          background-color: var(--grey4a);
          color: white;
        }
      }

      &.squared-outlined {
        & > div {
          border: ${px(2)} solid var(--grey4a);
        }
      }

      &.squared-outlined-2 {
        & > div {
          border: ${px(2)} solid var(--grey4a);
          padding: ${px(2)};
          & > div {
            border: ${px(1)} solid var(--grey4a);
          }
        }
      }

      &.circle-outlined-2,
      &.circle-filled {
        & > div {
          background-color: #fa7868;
          border-radius: 50%;
          color: white;
        }
      }

      &.circle-filled-result {
        & > div {
          background-color: white;
          box-shadow: 3px 3px 5px 0px var(--grey8e);
          color: black;
        }
      }

      &.circle-outlined {
        & > div {
          border: ${px(2)} solid #fa7868;
          border-radius: 50%;
        }
      }

      &.value-wrapper {
        padding-top: ${px(10)};
        padding-bottom: ${px(10)};

        &.lines-1::before {
          content: '';
          display: block;
          margin: 0 auto;
          width: 40%;
          border-top: ${px(2)} solid var(--dark);
          height: ${px(3)};
          position: absolute;
          bottom: ${px(-1)};
          left: 30%;
        }

        &.lines-2::after {
          border-bottom: ${px(2)} solid var(--dark);
          border-top: ${px(2)} solid var(--dark);
          bottom: ${px(-1)};
          content: '';
          display: block;
          left: 30%;
          margin: 0 auto;
          height: ${px(6)};
          position: absolute;
          width: 40%;
        }

        &.lines-3::after {
          border-bottom: ${px(2)} solid var(--dark);
          border-top: ${px(2)} solid var(--dark);
          bottom: ${px(-1)};
          content: '';
          display: block;
          left: 30%;
          margin: 0 auto;
          height: ${px(6)};
          position: absolute;
          width: 40%;
        }

        &.lines-3::before {
          content: '';
          display: block;
          margin: 0 auto;
          width: 40%;
          border-top: ${px(2)} solid var(--dark);
          height: ${px(3)};
          position: absolute;
          bottom: ${px(-1)};
          left: 30%;
        }
      }
    }
  }

  .thead {
    margin-top: 0;
    margin-bottom: 0;
    color: white;
    background-color: var(--grey9b);
    border-bottom: 1px solid #d8d8d8;
  }

  &.summary-table-form {
    position: absolute;
    bottom: ${px(100)};
    z-index: 1;
    opacity: 1;
    transition: opacity 0.3s linear, bottom 0.3s ease-in-out;

    &.hidden {
      z-index: 0;
      bottom: 0;
      opacity: 0;
    }
  }
`;
